import { render, staticRenderFns } from "./AnswerContainer.vue?vue&type=template&id=24cdc792&scoped=true"
import script from "./AnswerContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswerContainer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AnswerContainer.vue?vue&type=style&index=0&id=24cdc792&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cdc792",
  null
  
)

export default component.exports